enum BlockKey {
  LECTURES = 'lectures',
  PROJECT = 'project',
}

export { BlockKey };
